<template>
  <div class="basic-setting-content pl16 pr16">
    <el-form ref="form" label-width="180px" size="small">
      <div class="poster_footer">
        <el-button icon="el-icon-printer" type="primary" @click="imagePrint">打印</el-button>
      </div>
      <el-form-item label="打印方式：">
        <el-radio-group v-model="radio" @change="onTypeChange">
          <el-radio :label="20">二维码</el-radio>
          <el-radio :label="31">小程序码</el-radio>
          <el-radio :label="10">海报</el-radio>
        </el-radio-group>
      </el-form-item>

      <div class="poster_container">
        <ImagePreview :fit="fit" :src="poster_img"></ImagePreview>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import printJS from 'print-js';
import ImagePreview from "@/components/ImagePreview/index.vue";

export default {
  components: {
    ImagePreview
  },
  data() {
    return {
      poster_img: '',
      fit: 'cover',
      poster_height: 600,
      poster_width: '100%',
      radio: 20
    };
  },
  inject: ['form'],
  created() {
  },
  mounted() {
    this.genPoster(this.radio)
  },
  methods: {
    genPoster(type) {
      let self = this;
      PorductApi.genPoster({
        productId: self.form.model.id,
        source: type
      }, true)
        .then(res => {
          self.poster_img = res.data;
        })
        .catch(error => {
        });
    },
    onTypeChange(value) {
      this.poster_img = ''
      this.genPoster(value);
    },
    imagePrint() {
      let self = this;
      if (self.poster_img === '') {
        self.$message.info('海报还未生成，请稍后再试');
        return
      }
      printJS({
        printable: [
          self.poster_img
        ],
        type: 'image',
        imageStyle: 'width:100%;',
      });
    },
    /*删除设备图片*/
    deleteImg(index) {
      this.form.model.contentImage.splice(index, 1);
    },
  }
};
</script>

<style>
.poster_container {
  display: flex;
  justify-content: center;
}

.poster_footer {
  display: flex;
  justify-content: center;
  margin: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Poster.vue